import {Component, ElementRef, forwardRef, Injector, OnInit} from '@angular/core';
import {AbstractInput} from '../abstract-input';
import {NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
    providers: [
        {
            multi: true,
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PasswordInputComponent)
        }
    ],
    selector: 'vui-password-input',
    templateUrl: './password-input.component.html',
    styleUrls: ['./password-input.component.scss']
})
export class PasswordInputComponent extends AbstractInput {
    constructor(protected injector: Injector) {
        super(injector);
    }
}
